var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      staticClass: "text-left",
      attrs: { app: "", color: "primary", clippedLeft: "" },
    },
    [
      _vm.user.logo_url != ""
        ? _c("v-img", {
            attrs: {
              src: _vm.user.logo_url,
              "max-height": "40",
              contain: "",
              position: "left center",
            },
          })
        : _vm._e(),
      _c("v-spacer"),
      !_vm.phone_numbers.loading && _vm.phone_numbers.numbers.length > 0
        ? _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              { attrs: { text: "" } },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("v-icon", [_vm._v(" mdi-phone ")]),
                            _vm.user && _vm.user.current_phone_number
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.user.current_phone_number
                                        .friendly_name
                                    )
                                  ),
                                ])
                              : _c("span", [_vm._v("Select Phone Number")]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3868093117
              ),
            },
            [
              _c(
                "v-list",
                _vm._l(_vm.phone_numbers.numbers, function (phone_number) {
                  return _c(
                    "v-list-item",
                    {
                      key: phone_number.sid,
                      on: {
                        click: function ($event) {
                          return _vm.user.saveCurrentPhoneNumber(phone_number)
                        },
                      },
                    },
                    [
                      _c("v-list-item-title", {}, [
                        _vm._v(_vm._s(phone_number.friendly_name)),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm.phone_numbers.loading
        ? _c(
            "v-btn",
            { attrs: { icon: "", loading: "" } },
            [_c("v-icon", [_vm._v(" mdi-loading ")])],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            centered: !!_vm.app.snackbar.settings.centered,
            color: _vm.app.snackbar.settings.color,
            top: !!_vm.app.snackbar.settings.top,
            timeout: _vm.app.snackbar.timeout,
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.app.snackbar.settings.show = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_c("v-icon", [_vm._v("mdi-close-circle")])],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.app.snackbar.settings.show,
            callback: function ($$v) {
              _vm.$set(_vm.app.snackbar.settings, "show", $$v)
            },
            expression: "app.snackbar.settings.show",
          },
        },
        [_vm._v(" " + _vm._s(_vm.app.snackbar.settings.message) + " ")]
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "500", persistent: "", "overlay-opacity": "1" },
          model: {
            value: _vm.app.show_login_dialog,
            callback: function ($$v) {
              _vm.$set(_vm.app, "show_login_dialog", $$v)
            },
            expression: "app.show_login_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-h5 primary" },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-lock")]),
                  _vm._v(" Account Login "),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "px-6 pt-6 pb-0" },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "error",
                        text: "",
                        icon: "mdi-alert-circle",
                      },
                      model: {
                        value: _vm.app.show_login_error,
                        callback: function ($$v) {
                          _vm.$set(_vm.app, "show_login_error", $$v)
                        },
                        expression: "app.show_login_error",
                      },
                    },
                    [_vm._v("Login failed")]
                  ),
                  _c("p", [_vm._v("Please log in:")]),
                  _c("v-text-field", {
                    attrs: { label: "Email", outlined: "" },
                    model: {
                      value: _vm.login.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.login, "email", $$v)
                      },
                      expression: "login.email",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: "Password",
                      type: "password",
                      outlined: "",
                    },
                    model: {
                      value: _vm.login.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.login, "password", $$v)
                      },
                      expression: "login.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-6 pb-6 pt-0 mt-0" },
                [
                  _c(
                    "v-btn",
                    { attrs: { text: "", color: "grey", "x-small": "" } },
                    [_vm._v("Forgot Password")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.app.is_logging_in,
                        disabled: _vm.app.is_logging_in,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.app.doLogin(
                            _vm.login.email,
                            _vm.login.password
                          )
                        },
                      },
                    },
                    [_vm._v(" Login ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.app.show_app_overlay, opacity: "1" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
          _c("div", [_vm._v(_vm._s(_vm.app.app_overlay_text))]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }